import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationServices } from '../../../../appauth/notification/notificatio.services';
import { CustomValidators } from 'ng2-validation';
import { Aportesperiodos } from '../../aportesperiodo/aportesperiodos.model';
import { AportesperiodosServices } from '../../aportesperiodo/aportesperiodos.services';
import { Aportes } from '../../../aportes/aporte/aportes.model';
import { AportesServices } from '../../../aportes/aporte/aportes.services';
import { Subperiodos } from '../../../subperiodos/subperiodo/subperiodos.model';
import { SubperiodosServices } from '../../../subperiodos/subperiodo/subperiodos.services';

@Component({
	selector: 'app-addaportesperiodo',
	templateUrl: './addaportesperiodo.component.html',
	styleUrls: ['./addaportesperiodo.component.scss']
})

export class AddAportesperiodoComponent implements OnInit {
	public dataAportes:any;
	public dataSubperiodos:any;
	public formAddAportesperiodo: FormGroup;

	constructor(private fb: FormBuilder,
		private activeModal:NgbActiveModal,
		private servicioAportesperiodo:AportesperiodosServices,
		private servicioAporte:AportesServices,
		private servicioSubperiodo:SubperiodosServices,
		private Noti:NotificationServices,) { }

	ngOnInit() {
		this.servicioAporte.getDataAportes(1).subscribe((data:any)=>{
			this.dataAportes=data.aportes;
		});
		this.servicioSubperiodo.getDataSubperiodos().subscribe((data:any)=>{
			this.dataSubperiodos=data.subperiodos;
		});
		this.formAddAportesperiodo = this.fb.group({
			aporte_id:[null,Validators.compose([Validators.required,CustomValidators.number])],
			subperiodo_id:[null,Validators.compose([Validators.required,CustomValidators.number])],
			estado:[1,null],
		});
	}


	save(){
		let aportesperiodoDataModel:Aportesperiodos=this.formAddAportesperiodo.value;
		this.servicioAportesperiodo.saveAportesperiodos(aportesperiodoDataModel).subscribe((data:any)=>{
			if(data.estado){
				this.Noti.setNotification(data).then((datas)=>{
					if(datas){
						this.activeModal.close(1);
					}
				});
			}else{
				this.Noti.setNotification(data);
			}
		});
	}

	cerrarModal(){
		this.activeModal.close(2);
	}
}